import { render } from "./StartMenuOptionComponent.vue?vue&type=template&id=93f1596e"
import script from "./StartMenuOptionComponent.vue?vue&type=script&lang=js"
export * from "./StartMenuOptionComponent.vue?vue&type=script&lang=js"

import "./StartMenuOptionComponent.vue?vue&type=style&index=0&id=93f1596e&lang=css"

import exportComponent from "/codebuild/output/src794593303/src/git-codecommit.us-west-2.amazonaws.com/v1/repos/viracocha-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__